"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordRecord = exports.LoginId = exports.LoginIDType = exports.Device = exports.EmailPasswordRegistrationRequest = exports.UserActionToken = exports.UsersSort = exports.UserStatus = exports.UserProfile = exports.PartialUser = exports.User = exports.RoleAssignment = exports.UserType = exports.Identity = void 0;
var json2typescript_1 = require("json2typescript");
var Identity = (function () {
    function Identity(partial) {
        this.id = '';
        this.providerType = '';
        this.providerId = '';
        this.providerData = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('id', String, true),
        __metadata("design:type", Object)
    ], Identity.prototype, "id", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('provider_type'),
        __metadata("design:type", Object)
    ], Identity.prototype, "providerType", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('provider_id'),
        __metadata("design:type", Object)
    ], Identity.prototype, "providerId", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('provider_data', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], Identity.prototype, "providerData", void 0);
    Identity = __decorate([
        (0, json2typescript_1.JsonObject)('Identity'),
        __metadata("design:paramtypes", [Object])
    ], Identity);
    return Identity;
}());
exports.Identity = Identity;
var UserType;
(function (UserType) {
    UserType["Server"] = "server";
    UserType["Normal"] = "normal";
    UserType["System"] = "system";
    UserType["Unknown"] = "unknown";
})(UserType = exports.UserType || (exports.UserType = {}));
var RoleAssignment = (function () {
    function RoleAssignment(partial) {
        this.roleName = '';
        this.groupId = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('role_name'),
        __metadata("design:type", Object)
    ], RoleAssignment.prototype, "roleName", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('group_id', String, true),
        __metadata("design:type", String)
    ], RoleAssignment.prototype, "groupId", void 0);
    RoleAssignment = __decorate([
        (0, json2typescript_1.JsonObject)('RoleAssignment'),
        __metadata("design:paramtypes", [Object])
    ], RoleAssignment);
    return RoleAssignment;
}());
exports.RoleAssignment = RoleAssignment;
var User = (function () {
    function User(partial) {
        this.id = '';
        this.domainId = '';
        this.identities = undefined;
        this.data = undefined;
        this.sessionsValidSince = 0;
        this.creationDate = 0;
        this.value = 0;
        this.disabled = false;
        this.type = UserType.Unknown;
        this.roles = undefined;
        this.customData = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('_id'),
        __metadata("design:type", Object)
    ], User.prototype, "id", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('domain_id'),
        __metadata("design:type", Object)
    ], User.prototype, "domainId", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('identities', [Identity], true),
        __metadata("design:type", Array)
    ], User.prototype, "identities", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('data', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], User.prototype, "data", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('sessions_valid_since'),
        __metadata("design:type", Object)
    ], User.prototype, "sessionsValidSince", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('creation_date'),
        __metadata("design:type", Object)
    ], User.prototype, "creationDate", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('last_authentication_date'),
        __metadata("design:type", Object)
    ], User.prototype, "value", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('disabled'),
        __metadata("design:type", Object)
    ], User.prototype, "disabled", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('type'),
        __metadata("design:type", String)
    ], User.prototype, "type", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('roles', [RoleAssignment], true),
        __metadata("design:type", Array)
    ], User.prototype, "roles", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('custom_data', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], User.prototype, "customData", void 0);
    User = __decorate([
        (0, json2typescript_1.JsonObject)('User'),
        __metadata("design:paramtypes", [Object])
    ], User);
    return User;
}());
exports.User = User;
var PartialUser = (function () {
    function PartialUser(partial) {
        this.id = '';
        this.identities = undefined;
        this.type = UserType.Unknown;
        this.name = 0;
        this.value = 0;
        this.disabled = false;
        this.data = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('_id'),
        __metadata("design:type", Object)
    ], PartialUser.prototype, "id", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('identities', [Identity], true),
        __metadata("design:type", Array)
    ], PartialUser.prototype, "identities", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('type'),
        __metadata("design:type", String)
    ], PartialUser.prototype, "type", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('creation_date'),
        __metadata("design:type", Object)
    ], PartialUser.prototype, "name", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('last_authentication_date'),
        __metadata("design:type", Object)
    ], PartialUser.prototype, "value", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('disabled'),
        __metadata("design:type", Object)
    ], PartialUser.prototype, "disabled", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('data', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], PartialUser.prototype, "data", void 0);
    PartialUser = __decorate([
        (0, json2typescript_1.JsonObject)('PartialUser'),
        __metadata("design:paramtypes", [Object])
    ], PartialUser);
    return PartialUser;
}());
exports.PartialUser = PartialUser;
var UserProfile = (function () {
    function UserProfile(partial) {
        this.userId = '';
        this.domainId = '';
        this.identities = undefined;
        this.customData = undefined;
        this.data = {};
        this.type = UserType.Unknown;
        this.roles = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('user_id'),
        __metadata("design:type", Object)
    ], UserProfile.prototype, "userId", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('domain_id'),
        __metadata("design:type", Object)
    ], UserProfile.prototype, "domainId", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('identities', [Identity], true),
        __metadata("design:type", Array)
    ], UserProfile.prototype, "identities", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('custom_data', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], UserProfile.prototype, "customData", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('data'),
        __metadata("design:type", Object)
    ], UserProfile.prototype, "data", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('type'),
        __metadata("design:type", String)
    ], UserProfile.prototype, "type", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('roles', [RoleAssignment], true),
        __metadata("design:type", Array)
    ], UserProfile.prototype, "roles", void 0);
    UserProfile = __decorate([
        (0, json2typescript_1.JsonObject)('UserProfile'),
        __metadata("design:paramtypes", [Object])
    ], UserProfile);
    return UserProfile;
}());
exports.UserProfile = UserProfile;
var UserStatus;
(function (UserStatus) {
    UserStatus["Enabled"] = "enabled";
    UserStatus["Disabled"] = "disabled";
})(UserStatus = exports.UserStatus || (exports.UserStatus = {}));
var UsersSort;
(function (UsersSort) {
    UsersSort["Id"] = "_id";
    UsersSort["Status"] = "status";
    UsersSort["CreatedDate"] = "created_date";
    UsersSort["LastAuthDate"] = "last_authentication_date";
})(UsersSort = exports.UsersSort || (exports.UsersSort = {}));
var UserActionToken = (function () {
    function UserActionToken(partial) {
        this.tokenId = '';
        this.token = '';
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('token_id'),
        __metadata("design:type", Object)
    ], UserActionToken.prototype, "tokenId", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('token'),
        __metadata("design:type", Object)
    ], UserActionToken.prototype, "token", void 0);
    UserActionToken = __decorate([
        (0, json2typescript_1.JsonObject)('UserActionToken'),
        __metadata("design:paramtypes", [Object])
    ], UserActionToken);
    return UserActionToken;
}());
exports.UserActionToken = UserActionToken;
var EmailPasswordRegistrationRequest = (function () {
    function EmailPasswordRegistrationRequest(partial) {
        this.email = '';
        this.password = '';
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('email'),
        __metadata("design:type", Object)
    ], EmailPasswordRegistrationRequest.prototype, "email", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('password'),
        __metadata("design:type", Object)
    ], EmailPasswordRegistrationRequest.prototype, "password", void 0);
    EmailPasswordRegistrationRequest = __decorate([
        (0, json2typescript_1.JsonObject)('EmailPasswordRegistrationRequest'),
        __metadata("design:paramtypes", [Object])
    ], EmailPasswordRegistrationRequest);
    return EmailPasswordRegistrationRequest;
}());
exports.EmailPasswordRegistrationRequest = EmailPasswordRegistrationRequest;
var Device = (function () {
    function Device(partial) {
        this.id = '';
        this.clientAppVersion = '';
        this.platform = '';
        this.platformVersion = '';
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('_id'),
        __metadata("design:type", Object)
    ], Device.prototype, "id", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('client_app_version'),
        __metadata("design:type", Object)
    ], Device.prototype, "clientAppVersion", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('platform'),
        __metadata("design:type", Object)
    ], Device.prototype, "platform", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('platform_version'),
        __metadata("design:type", Object)
    ], Device.prototype, "platformVersion", void 0);
    Device = __decorate([
        (0, json2typescript_1.JsonObject)('Device'),
        __metadata("design:paramtypes", [Object])
    ], Device);
    return Device;
}());
exports.Device = Device;
var LoginIDType;
(function (LoginIDType) {
    LoginIDType["Email"] = "email";
    LoginIDType["Username"] = "username";
})(LoginIDType = exports.LoginIDType || (exports.LoginIDType = {}));
var LoginId = (function () {
    function LoginId(partial) {
        this.idType = LoginIDType.Email;
        this.id = '';
        this.confirmed = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('id_type'),
        __metadata("design:type", String)
    ], LoginId.prototype, "idType", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('id'),
        __metadata("design:type", Object)
    ], LoginId.prototype, "id", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('confirmed', Boolean, true),
        __metadata("design:type", Boolean)
    ], LoginId.prototype, "confirmed", void 0);
    LoginId = __decorate([
        (0, json2typescript_1.JsonObject)('LoginId'),
        __metadata("design:paramtypes", [Object])
    ], LoginId);
    return LoginId;
}());
exports.LoginId = LoginId;
var PasswordRecord = (function () {
    function PasswordRecord(partial) {
        this.id = '';
        this.domainId = '';
        this.loginIds = [];
        this.userId = '';
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('_id'),
        __metadata("design:type", Object)
    ], PasswordRecord.prototype, "id", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('domain_id'),
        __metadata("design:type", Object)
    ], PasswordRecord.prototype, "domainId", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('login_ids'),
        __metadata("design:type", Array)
    ], PasswordRecord.prototype, "loginIds", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('user_id'),
        __metadata("design:type", Object)
    ], PasswordRecord.prototype, "userId", void 0);
    PasswordRecord = __decorate([
        (0, json2typescript_1.JsonObject)('PasswordRecord'),
        __metadata("design:paramtypes", [Object])
    ], PasswordRecord);
    return PasswordRecord;
}());
exports.PasswordRecord = PasswordRecord;
//# sourceMappingURL=User.js.map